"use strict";

(function () {
  var ROOT = "[data-product-form-wrapper]";
  var VARIANT = 'input.btn-check[name="id"]';
  var SUBMIT = "[data-product-submit]";
  var SECTION = ".section--product-main";
  var CTA = ".product-pdp__cta";
  var SLOT = ".pdp-klaviyo-slot";
  var HIDDEN = "pdp-bis-hidden";
  var VARIANTS_JSON = "pdp-variants-json";
  var KLAVIYO =
    ".klaviyo-bis-button-container, a.klaviyo-bis-trigger, #klaviyo-bis-trigger";

  var debounce = null;
  var moTimer = null;
  var variantsCache = null;
  var klaviyoBisState = "on";
  var lastOosVariantId = null;

  function sectionEl() {
    var w = document.querySelector(ROOT);
    return (w && w.closest(SECTION)) || document.querySelector(SECTION) || document.body;
  }

  function hasBisSlot() {
    return !!document.querySelector(SLOT + "[klaviyo-bis-trigger]");
  }

  function getVariants() {
    if (variantsCache) return variantsCache;
    var el = document.getElementById(VARIANTS_JSON);
    if (!el) return null;
    try {
      variantsCache = JSON.parse(el.textContent);
      return variantsCache;
    } catch (e) {
      return null;
    }
  }

  function variantData(variantId) {
    var list = getVariants();
    if (!list) return { id: Number(variantId) };
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(variantId)) return list[i];
    }
    return { id: Number(variantId) };
  }

  function selectedVariant() {
    var root = document.querySelector(ROOT);
    return root ? root.querySelector(VARIANT + ":checked") : null;
  }

  function isInStock() {
    var v = selectedVariant();
    return v && v.getAttribute("data-variant-available") === "true";
  }

  function isBisManaged() {
    return klaviyoBisState === "on" && hasBisSlot();
  }

  function isKlaviyoNode(el) {
    if (!el || el.matches(SUBMIT) || el.matches(VARIANT) || el.matches(SLOT)) {
      return false;
    }
    if (el.closest(".product-pdp__sizes")) return false;
    if (el.classList.contains("klaviyo-bis-button-container")) return true;
    if (el.matches("a.klaviyo-bis-trigger, #klaviyo-bis-trigger")) return true;
    if (el.closest(".klaviyo-bis-button-container")) return true;
    var text = (el.textContent || "").replace(/\s+/g, " ").trim().toUpperCase();
    return el.matches("a, button") && text.indexOf("NOTIFY") !== -1;
  }

  function forEachKlaviyoNode(fn) {
    sectionEl().querySelectorAll(KLAVIYO + ", a, button").forEach(function (el) {
      if (isKlaviyoNode(el)) fn(el);
    });
  }

  function hasVisibleKlaviyoButton() {
    var found = false;
    forEachKlaviyoNode(function (el) {
      if (!el.classList.contains(HIDDEN)) found = true;
    });
    return found;
  }

  function hideKlaviyo() {
    forEachKlaviyoNode(function (el) {
      el.classList.add(HIDDEN);
    });
  }

  function showKlaviyo() {
    forEachKlaviyoNode(function (el) {
      el.classList.remove(HIDDEN);
    });
  }

  function updateVariantUrl(variantId) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variantId);
      window.history.replaceState({}, "", url);
    } catch (e) {}
  }

  function dispatchVariantChange(variantId) {
    document.dispatchEvent(
      new CustomEvent("variant:change", {
        bubbles: true,
        detail: { variant: variantData(variantId) },
      })
    );
  }

  function initKlaviyoBis() {
    if (window._klaviyo && typeof window._klaviyo.init === "function") {
      try {
        window._klaviyo.init();
      } catch (e) {}
    }
  }

  function remountKlaviyoSlot() {
    var slot = document.querySelector(SLOT);
    if (!slot) return;
    var cta = document.querySelector(CTA);
    if (cta) {
      cta.querySelectorAll(".klaviyo-bis-button-container").forEach(function (n) {
        n.remove();
      });
    }
    var fresh = document.createElement("div");
    fresh.className = "pdp-klaviyo-slot";
    fresh.setAttribute("klaviyo-bis-trigger", "");
    slot.replaceWith(fresh);
  }

  function updateSubmitSoldOut(inStock) {
    var submit = document.querySelector(SUBMIT);
    if (!submit) return;
    if (inStock) {
      submit.disabled = false;
      submit.hidden = false;
      submit.classList.remove("d-none", "btn-secondary", HIDDEN);
      submit.value = submit.getAttribute("data-add-to-cart-text") || "Add to cart";
      submit.classList.add("btn-dark");
    } else {
      submit.disabled = true;
      submit.hidden = false;
      submit.classList.remove("d-none", "btn-dark", HIDDEN);
      submit.value = submit.getAttribute("data-soldout-text") || "Sold out";
      submit.classList.add("btn-secondary");
    }
  }

  function updateSubmitKlaviyo(inStock) {
    var submit = document.querySelector(SUBMIT);
    if (!submit) return;
    if (inStock) {
      submit.disabled = false;
      submit.hidden = false;
      submit.classList.remove("d-none", "btn-secondary", HIDDEN);
      submit.value = submit.getAttribute("data-add-to-cart-text") || "Add to cart";
      submit.classList.add("btn-dark");
    } else {
      submit.disabled = true;
      submit.hidden = true;
      submit.classList.add("d-none", HIDDEN);
      submit.classList.remove("btn-dark", "btn-secondary");
    }
  }

  function setVariantBodyState(inStock) {
    document.body.classList.toggle("pdp-variant-in-stock", inStock);
    document.body.classList.toggle("pdp-variant-oos", !inStock);
    var root = document.querySelector(ROOT);
    if (root) root.setAttribute("data-variant-in-stock", inStock ? "true" : "false");
  }

  function refreshKlaviyoForOos(force) {
    var v = selectedVariant();
    if (!v) return;
    if (!force && lastOosVariantId === v.value) return;
    lastOosVariantId = v.value;

    updateVariantUrl(v.value);
    v.dispatchEvent(new Event("change", { bubbles: true }));
    dispatchVariantChange(v.value);
    remountKlaviyoSlot();
    initKlaviyoBis();
  }

  function scheduleOosKlaviyo() {
    [250, 700, 1500, 3000].forEach(function (ms) {
      setTimeout(function () {
        if (!isBisManaged() || isInStock()) return;
        var v = selectedVariant();
        if (!v) return;
        updateVariantUrl(v.value);
        dispatchVariantChange(v.value);
        initKlaviyoBis();
        showKlaviyo();
        if (!hasVisibleKlaviyoButton() && ms >= 3000) {
          updateSubmitSoldOut(false);
        }
      }, ms);
    });
  }

  function syncVisibility() {
    if (!isBisManaged()) return;
    if (isInStock()) hideKlaviyo();
    else showKlaviyo();
  }

  function apply() {
    var inStock = isInStock();

    if (!isBisManaged()) {
      document.body.classList.remove("pdp-variant-in-stock", "pdp-variant-oos");
      document.body.setAttribute("data-klaviyo-bis", "off");
      updateSubmitSoldOut(inStock);
      hideKlaviyo();
      return;
    }

    document.body.setAttribute("data-klaviyo-bis", "on");
    setVariantBodyState(inStock);

    if (inStock) {
      lastOosVariantId = null;
      updateSubmitKlaviyo(true);
      hideKlaviyo();
      return;
    }

    updateSubmitKlaviyo(false);
    showKlaviyo();
    refreshKlaviyoForOos(false);
    scheduleOosKlaviyo();
  }

  function scheduleApply() {
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(function () {
      debounce = null;
      apply();
    }, 30);
  }

  function onDomChange() {
    if (!isBisManaged()) return;
    if (moTimer) clearTimeout(moTimer);
    moTimer = setTimeout(function () {
      moTimer = null;
      syncVisibility();
      if (!isInStock() && !hasVisibleKlaviyoButton()) {
        initKlaviyoBis();
      }
    }, 120);
  }

  function init() {
    var root = document.querySelector(ROOT);
    if (!root) return;

    klaviyoBisState = hasBisSlot() ? "on" : "off";
    document.body.setAttribute("data-klaviyo-bis", klaviyoBisState);

    root.addEventListener("change", function (e) {
      if (e.target && e.target.matches(VARIANT)) scheduleApply();
    });

    root.addEventListener("click", function (e) {
      if (e.target && e.target.closest("label[for^='variant-id-']")) scheduleApply();
    });

    apply();

    window.addEventListener("load", function () {
      if (hasBisSlot()) {
        klaviyoBisState = "on";
        document.body.setAttribute("data-klaviyo-bis", "on");
      }
      apply();
    });

    new MutationObserver(onDomChange).observe(sectionEl(), {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
